import React, { useState } from "react";

import { IPanelProps, Panel } from "core/decorators/Panel";
import { Card, Elevation } from "@blueprintjs/core";
import Query from "core/api/QueryComponent";
import Institution, { ObjStoreFile } from "panels/catalog/entities/institution";
import TokenSession from "core/util/session/TokenSession";
import Loading from "common/fragments/Loading";
import InstitutionsLogoConfig from "./InstitutionsLogoConfig";


@Panel({
    id: "institution-logo",
    pageParams: true,
    configClass: InstitutionsLogoConfig
})
class InstitutionsLogoPanel extends React.PureComponent<IPanelProps<InstitutionsLogoConfig>, {}> {
    public constructor(props: IPanelProps<InstitutionsLogoConfig>) {
        super(props);
    }
    public render() {
        const { pageParams, actions } = this.props;
        const institution = pageParams["institution"];
        const institutions = TokenSession.getUserInstitutions();

        if(institutions == null) return null;

        const inst = institutions.filter(inst => inst.guid == institution)

        if(inst === null) return null;

        return (
            <Query.One entity={Institution} args={{ id: inst[0].id }}>
                {(args) => {
                    if (args.data) {
                        const instutute = args.data;
                        // First check if we have a direct URL to use
						if (instutute.logo && instutute.logo.file && instutute.logo.file.url) {
							return (
								<img
									src={instutute.logo.file.url}
									width={this.props.config.maxWidth}
									height={this.props.config.maxHeight}
								/>
							);
						}

						// Fall back to object ID approach if no direct URL is available
                        const objId = instutute.logo && instutute.logo.file && instutute.logo.file.obj && instutute.logo.file.obj.id;
                        if (objId) {
                            return <Query.One entity={ObjStoreFile} args={{ id: objId }}>
                                {({ data, loading }) => {

                                    if (loading) {
                                        return <Loading key="loading" />;
                                    }
                                   if(data!=null && data.data!=null)
                                        return (
                                            <img src={`data:image/png;base64,${data.data}`} width={this.props.config.maxWidth}  height={this.props.config.maxHeight} />
                                       )
                                    else
                                        return null;
                                }}
                            </Query.One>
                        }
                    }

                    return null
                }}
            </Query.One>
        );
    }
}
export default InstitutionsLogoPanel;



// WEBPACK FOOTER //
// ./src/panels/institutions/institutionLogo/InstitutionsLogo.panel.tsx